var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8f00",
    d: "M42 11L47.691 9 42 7 36.309 9zM43 12.667L43 19 48 17.333 48 11zM41 12.667L36 11 36 17.333 41 19zM28 11L33.691 9 28 7 22.309 9zM29 12.667L29 19 34 17.333 34 11zM27 12.667L22 11 22 17.333 27 19zM21 23L26.691 21 21 19 15.309 21zM22 24.667L22 31 27 29.333 27 23zM20 24.667L15 23 15 29.333 20 31zM7 23L12.691 21 7 19 1.309 21zM8 24.667L8 31 13 29.333 13 23zM6 24.667L1 23 1 29.333 6 31zM14 35L19.691 33 14 31 8.309 33zM15 36.667L15 43 20 41.333 20 35zM13 36.667L8 35 8 41.333 13 43z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon-s3.b5daa624ff464e4f27a7bcc0c8044787.svg";
export { ForwardRef as ReactComponent };